import { render, staticRenderFns } from "./WorkshopSelect.vue?vue&type=template&id=69506ce4&"
import script from "./WorkshopSelect.vue?vue&type=script&lang=js&"
export * from "./WorkshopSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports